export const isStarterBookingBlocked = (user = {}) => {
  const value = user.is_starter_booking_blocked;

  return value === true || value === 1 || value === "1" || value === "true";
};

export const canShowStarterBookingOption = (user = {}) => {
  return Number(user.is_starter) === 1 && !isStarterBookingBlocked(user);
};

export const canShowDonatedBookingOption = (appointmentCount) => {
  return Boolean(appointmentCount);
};

export const isOnDemandOnlyClient = (user = {}) => {
  const value = user.is_on_demand_only_client;

  return value === true || value === 1 || value === "1" || value === "true";
};

export const canShowImmediateSessionOption = (user = {}) => {
  return isOnDemandOnlyClient(user);
};

export const hasBlockedStarterBookingDraft = (draft = {}) => {
  return (
    draft.type === "newappointment" &&
    String(draft.activesession_id || "") === "3"
  );
};

export const clearStarterBookingDraft = (storage = window.localStorage) => {
  [
    "type",
    "subsession_id",
    "duration",
    "amount",
    "activeCurrency",
    "activesession_id",
    "redirect_to",
  ].forEach((key) => storage.removeItem(key));
};
